import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { getState } from "@bd-stores/store";
import { 
    getRoomStatus, 
    getFinalTeamAnswers 
} from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
    updateFinalRoomAnswer,
} from "@bd-core/firebase-actions";
import fb from "@bd-core/firebase";

export class RoomMatchCard extends BD_Component {
    constructor() {
        super();

        this.id = "match_card";
        this.templateID = "match_card-template";
        this.elms = {
            blur: ".app-blur",
            matchCardPuzzle: ".js-matchCard-puzzle",
            matchCardItem: ".js-matchCard-item",
            matchCardSlider: ".js-matchCard-slides",
            matchCardAnswerBtn: ".js-matchCard-answer",
            matchCardClearAnswerBtn: ".js-matchCard-clear-answer",
            matchCardSelectBtn: ".js-matchCard-select",
            matchCardSelectBtnParent: ".js-matchCard-overlay-select",
            matchCardAudioBtn: ".js-matchCard-audio",
            matchOverlay: ".js-matchCard-overlay",
            matchOverlayClose: ".js-matchOverlay-close",
            slotAnswerImage: ".js-match-answer-image",
            submitBtn: ".js-submit",
            check: ".check__result",
            openPuzzle: ".js-puzzle",
            openOverlay: ".js-overlay",
            selectOverlay: ".js-select-overlay",
            puzzleScreen: ".js-bg",
            continueBtn: ".js-continue",
            closeImgBtn: ".js-close-image",
            openImageBtn: ".js-open-badge",
            instructionBtn: ".js-instruction-btn",
            instructionTitle: ".js-instruction",

            // for puzzle part 2
            partTwoBtn: ".js-clues-puzzle",
            puzzlePartTwoScreen: ".js-part-2",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-submit-btn",
            continueBtnPart2: ".js-continue-btn",

            hintBtn: ".js-toby-hint",
            hintPopup: ".js-hints-popup",

            // toggle screen
            previousScreenBtn: ".js-prev-screen-room-2",
            nextScreenBtn: ".js-next-screen-room-2",
        };

        this._events = this.getEvents();

        /**
         * @type {Array<HTMLAudioElement>}
         */
        this.audios = [];

        /**
         * @type {BD_RoomMatchCards}
         */
        this._data = undefined;

        this.userAnswer = undefined;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onSubmitAnswer,
            },
            {
                event: "click",
                selector: elms.matchCardAudioBtn,
                handler: this.onPlayAudio,
            },
            {
                event: "click",
                selector: elms.matchCardSelectBtn,
                handler: this.onSelectCard,
            },
            {
                event: "click",
                selector: elms.matchCardClearAnswerBtn,
                handler: this.onClearAnswer,
            },
            {
                event: "click",
                selector: elms.openPuzzle,
                handler: this.onTogglePuzzlePartOne,
            },
            {
                event: "click",
                selector: elms.openOverlay,
                handler: this.onToggleMatchOverlay,
            },
            {
                event: "click",
                selector: elms.selectOverlay,
                handler: this.onSubmitSelectCard,
            },
            {
                event: "click",
                selector: elms.partTwoBtn,
                handler: this.goToPuzzlePartTwo,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "keyup",
                selector: elms.inputAnswer,
                handler: this.onDeleteInputAnswer
            },
            {
                event: "blur",
                selector: elms.inputAnswer,
                handler: this.onBlurInput,
            },
            {
                event: "focus",
                selector: elms.inputAnswer,
                handler: this.onInputFocus,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.onSubmitAnswerPart2
            },
            {
                event: "click",
                selector: elms.hintBtn,
                handler: this.handleOpenHint
            },
            {
                event: "click",
                selector: elms.continueBtn,
                handler: this.onPuzzlePartOneFinish
            },
            {
                event: "click",
                selector: elms.continueBtnPart2,
                handler: this.onPuzzlePartTwoFinish
            },
            {
                event: "click",
                selector: elms.previousScreenBtn,
                handler: this.togglePreviousScreen
            },
            {
                event: "click",
                selector: elms.nextScreenBtn,
                handler: this.toggleNextScreen
            },
            {
                event: "click",
                selector: ".js-reflection-close",
                handler: this.handleOnCloseReflectionPopupPart1
            },
            {
                event: "click",
                selector: ".js-completion-close",
                handler: this.goToReflectionPopupPart1
            },
            {
                event: "click",
                selector: ".js-briefing-close",
                handler: this.onCloseBriefingPopupPart2
            },
            {
                event: "click",
                selector: elms.closeImgBtn,
                handler: this.closeImage,
            },
            {
                event: "click",
                selector: elms.openImageBtn,
                handler: this.openBadge,
            },
            {
                event: "click",
                selector: elms.instructionBtn,
                handler: this.onOpenInstruction,
            }
        ];
    }

    beforeInit() {
    

        this.render();
        this.setGameState();
        // this.registerSounds();
        this.setMatchCardSlider();
        
        $(".js-toby-hint").addClass("is-hidden");
        
    }
   
    getModifiedData() {
        const modified = { ...this._data };
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/challenge2-bg.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const modifiedData = {
            ...modified,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);

        $(".app").html(html);
    }

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);
        const roomAnswers = getFinalTeamAnswers(roomId);
        const elms = this.elms;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (roomAnswers) {
            // @ts-ignore
            if (roomAnswers?.part_1) {
                $.each(roomAnswers, this.setViewAnswer.bind(this));
            }

            // @ts-ignore
            if (roomAnswers?.part_2) {
                // @ts-ignore
                const teamAnswers = roomAnswers.part_2;
                const answers =
                    typeof teamAnswers === "string"
                        ? [...teamAnswers]
                        : teamAnswers;

                if (Object.keys(answers).length == 0) return;

                $.each(answers, (index, value) => {
                    $(elms.puzzlePartTwoScreen)
                        .find(elms.inputAnswer)
                        // @ts-ignore
                        .eq(index)
                        .prop("readonly", true)
                        .val(value);
                });
            }

            if (thisRoomStatus === "is-status-open") {
                this.toggleNextScreen();
            }

            if (thisRoomStatus === "is-status-started"
                // @ts-ignore
                && roomAnswers?.part_1) {
                $(".js-overlay").prop("disabled", true);
                $(".js-matchCard-clear-answer").prop("disabled", true);
                $(".js-matchCard-clear-answer").css({ "background-color": "rgba(0, 0, 0, .3)" });
                this.togglePreviousScreen();
                $(".js-puzzle").addClass("is-completed")
                $(elms.matchCardPuzzle)
                    .removeClass("is-incorrect")
                    .addClass("is-correct");
            }

            if (thisRoomStatus === "is-status-completed") {
                $(elms.matchCardPuzzle)
                    .removeClass("is-selected is-incorrect")
                    .addClass("is-correct is-completed");

                $(elms.puzzlePartTwoScreen)
                    .removeClass("is-wrong is-incorrect")
                    .addClass("is-correct");

                $(elms.puzzleScreen)
                    .removeClass("primary-view secondary-view")
                    .addClass("tertiary-view");

                $(".app__page").addClass("is-room-completed");
            }

            fb.get(`${fb.roomsPath}/${roomId}/showingCompletionPart1`)
            .then((data) => {
                const isShowing = data.val();

                if(isShowing) {
                    this.handleCompletionPoupPart1();
                }
            });
        }
    }

    // ============================== CUSTOM FUNCTION
    setMatchCardSlider() {
        // const $slickTrack = $(".slick-track");
        
        $(".js-matchCards-slider").slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $(".js-prev"),
            nextArrow: $(".js-next"),
            dots: true,
            appendDots: $(".js-matchCard-paging"),
            customPaging: function (slider, i) {
                // eslint-disable-next-line no-unused-vars
                var thumb = $(slider.$slides[i]).data(); // Ensure data attributes are defined in the slides
                return '<a>' + [i + 1] + '</a>' + '<i>' + '</i>';
            }
        });
    
        if ($(".slick-slide").length <= 1) {
            $(".js-prev").css("opacity", "0")
            $(".js-next").css("opacity", "0")
        }

        if($('.matchCards__puzzle-item').length == 1){
            $('.js-matchCards-slider').slick('slickSetOption', 'slidesToShow', 0 , true)
                                      .find('.matchCards__puzzle-item').addClass('slider-item-1');
          $('.slick-dots a').on('click', function(){
              return false;
          });

          $(".slick-dots li:nth-child(2)").css("display", "none")
        }

        $(".js-matchCards-slider").on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(".js-prev").prop('disabled', nextSlide === 0);
            $(".js-next").prop('disabled', nextSlide === slick.slideCount - 1);
        });
    }
    

    closeImage() {
        $(".js-image").removeClass("is-open");
    }

    openBadge(e, el) {
        const $el = $(el);
        const $selectedImg = $el.find("img.js-slot-image");
        // con
        const imgUrl = $selectedImg.attr("src");
        const $popup = $(".js-image");

        $popup.find(".js-selected-image").attr("src", imgUrl);
        $popup.addClass("is-open");
    }

    onOpenInstruction() {
        const elms = this.elms;
        const $instructionTitle = $(elms.instructionTitle)
        const $isOpen = $instructionTitle.hasClass("is-open")
        
        if (!$isOpen) {
            $instructionTitle.addClass("is-open")
        } else {
            $instructionTitle.removeClass("is-open")
        }
    }


    onTogglePuzzlePartOne() {
        const elms = this.elms;
        const $matchCardPuzzle = $(elms.matchCardPuzzle);
        const $matchCardSlider = $(elms.matchCardSlider);
        const isMatchCardPuzzleOpened = $matchCardPuzzle.hasClass("is-open");
        const isMatchCardSliderOpened = $matchCardSlider.hasClass("is-open");

        $matchCardPuzzle.toggleClass("is-open", !isMatchCardPuzzleOpened);
        $matchCardSlider.toggleClass("is-open", !isMatchCardSliderOpened);

        $(elms.hintBtn).toggleClass("is-hidden", isMatchCardPuzzleOpened);

    }

    setRequiremtnSlider() {
        var $requirementSlider = $(".js-requirement-slider");
        var $reqPrev = $(".js-req-prev");
        var $reqNext = $(".js-req-next");
        var $requirementSlides = $(".js-requirement-slides");
        var $reqCurrent = $(".js-req-current");

        if ($requirementSlider.length && $reqPrev.length && $reqNext.length && $requirementSlides.length && $reqCurrent.length) {
            $requirementSlider.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: false,
                prevArrow: $reqPrev,
                nextArrow: $reqNext,
                dots: true,
                appendDots: $requirementSlides,
                customPaging: function (slider, i) {
                    // eslint-disable-next-line no-unused-vars
                    var thumb = $(slider.$slides[i]).data();
                    return '<a>' + '</a>';
                }
            });

            $requirementSlider.on("init", function (event, slick) {
                var numSlides = slick.slideCount;
                var currentSlide = slick.currentSlide + 1;

                $reqCurrent.html(currentSlide + ' / ' + numSlides);
            });

            $requirementSlider.on("afterChange", function (event, slick, currentSlide) {
                currentSlide = currentSlide + 1;
                var numSlides = slick.slideCount;
                $reqCurrent.html(currentSlide + ' / ' + numSlides);
            });

            $requirementSlider.slick('slickGoTo', 0);

            var slickInstance = $requirementSlider.slick('getSlick');
            var numSlides = slickInstance.slideCount;
            var currentSlide = slickInstance.currentSlide + 1;

            $reqCurrent.html(currentSlide + ' / ' + numSlides);
        } else {
            console.error("One or more elements not found.");
        }
    }

    registerSounds() {
        const elms = this.elms;
        const self = this;

        if (this.audios.length) {
            return false;
        }

        const $elBtnAudios = $(elms.matchCardAudioBtn);

        $.each($elBtnAudios, function (index, elBtnAudio) {
            const $audio = $(elBtnAudio);
            const audioUrl = $audio.attr("data-audio");
            const id = $audio.parents(elms.matchCardItem).attr("data-key");
            if (audioUrl) {
                const audio = new Audio(audioUrl);
                audio.id = id;
                self.audios.push(audio);
            }
        });
    }

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     */
    toggleCheckButton() {
        const elms = this.elms;
        const $matchCardPuzzle = $(elms.matchCardPuzzle);
        let isAnsweredAll = true;

        if ($(elms.submitBtn).hasClass("is-completed")) return false;

        $(elms.matchCardItem).each(function () {
            const isThisAnswered = $(this).hasClass("is-selected");
            if (!isThisAnswered) return (isAnsweredAll = false);
        });

        $(elms.submitBtn).prop("disabled", !isAnsweredAll);
        $matchCardPuzzle.toggleClass("is-selected", isAnsweredAll);
    }

    onToggleMatchOverlay(e, el) {
        if ($(".app__page").hasClass("is-room-completed")) return;

        const elms = this.elms;
        const $matchOverlay = $(elms.matchOverlay);
        const $matchSlider = $(elms.matchCardSlider);
        const isOpen = $(elms.matchOverlay).hasClass("is-open");

        $matchOverlay.toggleClass("is-open", !isOpen);
        $matchSlider.toggleClass("is-open", isOpen);

        if (!isOpen) {
            const $matchcard = $(el).parents(elms.matchCardItem);
            const $theImage = $matchcard.find("img.js-slot-image");
            const imageUrl = $theImage.attr("src");
            const key = $matchcard.attr("data-key");

            $matchOverlay.find("img#badge").attr("src", imageUrl);
            $matchOverlay.attr("data-active-key", key);
            $matchOverlay
                .find(elms.matchCardSelectBtnParent)
                .removeClass("active");
            $matchOverlay
                .find(
                    `${elms.matchCardSelectBtnParent}[data-active-key="${key}"]`,
                )
                .addClass("active");
        }
    }

    /* check player answers on puzzle part 1 */
    onSubmitAnswer(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const sttCompleted = "is-status-completed";

        if (
            $el.hasClass("is-loading") ||
            $el.hasClass("is-completed") ||
            sttCompleted === getRoomStatus(this.roomId)
        ) {
            return;
        }

        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        const $matchCardItems = $(elms.matchCardItem);
        const roomAnswers = getRoomAnswerById(roomID);
        const puzzlePartOne = roomAnswers?.part_1 || {};

        let roomStatus = "is-status-started";
        let playerAnswers = {};
        let statusClass = {};
        let statusPuzzle = "is-incorrect";
        let correct = 0;
        let wrong = 0;

        $.each($matchCardItems, function (index, item) {
            const $item = $(item);
            const cardId = $item.attr("data-key");
            const answer = $item.attr("data-answer");

            playerAnswers[cardId] = answer;
        });

        for (const key in playerAnswers) {
            const playerAnswer = playerAnswers[key];
            const correctAnswer = puzzlePartOne?.[key];
            let status = "is-incorrect";

            if (correctAnswer == playerAnswer) {
                correct++;
                status = "is-correct";
            } else {
                wrong++;
            }

            statusClass[key] = status;
        }

        const isAllCorrect = wrong == 0 && correct > 0;

        $el.removeClass("is-loading").removeAttr("disabled");

        if (isAllCorrect) {
            statusPuzzle = "is-correct";
            // roomStatus = sttCompleted;
            this.meSubmittingAnswer = true; // a flag to set the UI state

            const onSuccess = () => {
                $el.parent().parent().addClass("is-completed");
                this.updateCompletionState(true);
                // this.handleCompletionPoupPart1();
                // this.onPuzzlePartOneFinish();
            };

            const answersData = {
                part_1: playerAnswers
            };

            saveFinalRoomAnswers(roomID, answersData)
                .then(onSuccess)
                .catch(() => (this.meSubmittingAnswer = false));
        }

        $.each(statusClass, function (index, item) {
            const $theCard = $(`${elms.matchCardItem}[data-key="${index}"]`);
            const slickIndex = Number(
                $theCard
                    .parents(".slick-slide")
                    .not(".slick-cloned")
                    .attr("data-slick-index")
            );
            const $slickDot = $(".slick-dots").find("li").eq(slickIndex);
            $slickDot.addClass(item);
        });

        $(elms.matchCardPuzzle).addClass(statusPuzzle);

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    updateCompletionState(status) {
        const roomID = this.roomId;
        return fb.update(`${fb.roomsPath}/${roomID}`, {
            showingCompletionPart1: status
        });
    }

    handleCompletionPoupPart1() {
        const {puzzle_part_1} = this._data;
        const {completion_popup, reflection_popup} = puzzle_part_1;
        const $completion = $(".js-room-completion-part1");
        const $reflection = $(".js-room-reflection-part1");

        if(completion_popup.description !== "") {
            $completion.addClass("is-open");
        } else {
            if(reflection_popup.description !== "") {
                $reflection.addClass("is-open");
            } else {
                this.onPuzzlePartOneFinish();
            }
        }
    }

    goToReflectionPopupPart1() {
        const $completion = $(".js-room-completion-part1");
        const $reflection = $(".js-room-reflection-part1");

        $completion.removeClass("is-open");
        $reflection.addClass("is-open");
    }

    handleOnCloseReflectionPopupPart1(e, el) {
        const $el = $(el);
        const $popup = $el.parents(".js-room-reflection-part1");

        $popup.removeClass("is-open");
        this.updateCompletionState(false);
        this.onPuzzlePartOneFinish();
    }

    onPuzzlePartOneFinish() {
        const roomID = this.roomId;
        const roomStatus = getRoomStatus(roomID);
        if (roomStatus === "is-status-open") return;

        const elms = this.elms;
        const $puzzleScreen = $(elms.puzzleScreen);
        const $continueBtn = $(elms.continueBtn);

        $(".js-overlay").prop("disabled", true);
        $continueBtn
            .addClass("is-loading")
            .prop("disabled", true);

        setTimeout(() => {
            this.onTogglePuzzlePartOne();

            $puzzleScreen
                .removeClass("primary-view")
                .addClass("secondary-view");

            this.onOpenBriefingPopupPart2();
            this.togglePreviousScreen();

        }, 1850);

        $(".js-part-nav").removeClass("is-hidden")

        $(".js-puzzle").addClass("is-completed")
    }

    onPlayAudio(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const id = $el.parents(elms.matchCardItem).attr("data-key");

        this.playPauseAudio(id, el);
    }

    playPauseAudio(id, btnEl = null) {
        /** @type {HTMLAudioElement | undefined} */
        let theAudio;

        const elms = this.elms;
        const $matchCardItem = btnEl
            ? $(btnEl).parents(elms.matchCardItem)
            : false;

        $.each(this.audios, function (index, audio) {
            if (audio.id == id) {
                theAudio = audio;
            } else {
                if (!audio.paused) {
                    try {
                        audio.pause();
                        $(elms.matchCardItem).removeClass("is-playing");
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        });

        if (theAudio) {
            try {
                if (!theAudio.paused) {
                    theAudio.pause();
                    if ($matchCardItem)
                        $matchCardItem.removeClass("is-playing");

                    GameLogic.backgroundAudio.play();
                } else {
                    theAudio.play();

                    GameLogic.backgroundAudio.pause();

                    if ($matchCardItem) {
                        $(theAudio).on("ended", function () {
                            $matchCardItem.removeClass("is-playing");
                        });

                        $matchCardItem.addClass("is-playing");
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    onSelectCard(e, el) {
        if ($(".app__page").hasClass("is-room-completed")) return;
        const elms = this.elms;
        const $el = $(el);
        const hasSelected = $el.hasClass("has-selected");
        if (hasSelected) return;

        const $overlayCards = $(elms.matchCardSelectBtn).not(".has-selected");

        $.each($overlayCards, (index, value) => {
            $(value)
                .prop("checked", false);
        });

        $el
            .prop("checked", true);

        $(elms.selectOverlay).prop("disabled", hasSelected);
    }

    onSubmitSelectCard(e, el) {
        const elms = this.elms;
        const $el = $(el);

        const $matchSlider = $(elms.matchCardSlider);
        const $matchoverlay = $el.parents(elms.matchOverlay);
        const key = $matchoverlay.attr("data-active-key");
        const $selectedCard = $(`${elms.matchCardSelectBtn}:checked`).not(".has-selected");
        const chosenId = $selectedCard.parent().attr("data-id");

        this.setViewAnswer(key, chosenId);

        $selectedCard.addClass("has-selected");
        $matchoverlay.removeClass("is-open");
        $matchSlider.addClass("is-open");

        // const answerData = {
        //     [key]: chosenId,
        // };

        // this.userAnswer = answerData;
        // this.updateUserAnswer();
        this.toggleCheckButton();
    }

    setViewAnswer(key, answerValue) {
        const elms = this.elms;
        const $cardItem = $(elms.matchCardItem + `[data-key="${key}"]`);
        const theAnswer = answerValue?.answer || answerValue;
        const $answer = $(elms.matchCardSelectBtnParent + `[data-id="${theAnswer}"]`);
        const imageURL = $answer.attr("data-image");

        $cardItem.find(elms.slotAnswerImage).prop("src", imageURL);

        $cardItem.addClass("is-selected is-filled");
        $cardItem.attr("data-answer", theAnswer);
        this.toggleCheckButton();

        $(elms.matchCardSelectBtn).parent().removeClass("active");
    }

    onClearAnswer(e, el) {
        const elms = this.elms;
        const $matchcard = $(el).parents(elms.matchCardItem);
        const answerId = $matchcard.attr("data-answer");
        const $answer = $(elms.matchCardSelectBtnParent + `[data-id=${answerId}]`);

        $answer
            .find("input")
            .prop("checked", false)
            .removeClass("has-selected");

        $matchcard
            .removeClass("is-selected is-filled")
            .removeAttr("data-answer")
            .find(elms.slotAnswerImage)
            .removeAttr("src");

        $(elms.matchCardPuzzle).removeClass("is-incorrect");
        $(elms.matchCardPuzzle).removeClass("is-selected");
        $(elms.selectOverlay).prop("disabled", true);
        $(elms.submitBtn).prop("disabled", true);

        const slickIndex = Number(
            $matchcard
                .parents(".slick-slide")
                .not(".slick-cloned")
                .attr("data-slick-index")
        );
        const $slickDot = $(".slick-dots").find("li").eq(slickIndex);
        $slickDot.removeClass("is-incorrect");

        this.dischardUserAnswer(answerId);
    }

    beforeDestroy() {
        this.playPauseAudio(null);
    }

    updateUserAnswer() {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;

            const userAnswer = fbRoomAnswers[currentPlayerId]?.choice;
            const answerData = { ...userAnswer, ...answer };

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: answerData,
                },
            });
        });
    }

    dischardUserAnswer(answerId) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const userAns = fbRoomAnswers[currentPlayerId]?.choice;

            const userAnsw = Object.keys(userAns)
                .filter((answer) => {
                    return userAns[answer] != answerId;
                })
                .reduce((answ, key) => {
                    answ[key] = userAns[key];
                    return answ;
                }, {});

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: userAnsw,
                },
            });
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const slotID = hasContext
                ? $context.attr("data-slot-id")
                : undefined;
            const slotChoiceID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[slotID] == slotChoiceID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    /********** function for puzzle part 2 goes here **************/
    toggleNextScreen() {
        const $screenInner = $(".screen__inner")
        const $screenImg = $(".screen__img")
    

        $screenImg.removeClass("is-part-2")
        $screenImg.addClass("is-part-1")
        $screenInner.removeClass("is-part-2")
        $screenInner.addClass("is-part-1")
 
    }

    togglePreviousScreen() {
        const $screenInner = $(".screen__inner")
        const $screenImg = $(".screen__img")

        $screenImg.removeClass("is-part-1")
        $screenImg.addClass("is-part-2")
        $screenInner.removeClass("is-part-1")
        $screenInner.addClass("is-part-2")
    }

    handleOpenHint() {
        const elms = this.elms;
        const isPuzzlePart2Opened = $(".js-bg-room-2").hasClass("is-part-2");

        if (!isPuzzlePart2Opened) return;

        const { puzzle_part_2 } = this._data;
        const { toby_hint } = puzzle_part_2;
        const {
            description,
            button_label,
            result_text,
            result_button_label,
            hint_risk_level
        } = toby_hint;
        const $hintPopup = $(elms.hintPopup);

        $hintPopup.find(".js-hint-description").html(description);
        $hintPopup.find(".js-hint-result").html(result_text);
        $hintPopup.find(".js-using-hint").text(button_label);
        $hintPopup.find(".js-hint-result-btn").text(result_button_label);

        $hintPopup.find(".js-hint-risk")
            .removeClass("low medium high")
            .addClass(hint_risk_level)
            .attr("data-hint-risk", hint_risk_level);

        $hintPopup.removeClass("is-feedback");
        $hintPopup.addClass("is-open is-for-part-2");
    }

    onOpenBriefingPopupPart2() {
        const $briefingPopup = $(".js-briefing");
        const { puzzle_part_2 } = this._data;
        const { instruction_popup } = puzzle_part_2;
        const { 
            title, 
            description, 
            aiso_advice_text,
            button_label,
            aiso_risk_level
        } = instruction_popup;

        $briefingPopup.find(".js-briefing-title").children("popup__title-sm").html(title);
        $briefingPopup.find(".js-briefing-description").html(description);
        $briefingPopup.find(".js-briefing-aiso").html(aiso_advice_text);
        $briefingPopup.find(".js-briefing-close").text(button_label);
        $briefingPopup
            .find(".js-hint-risk")
            .removeClass("low medium high")
            .addClass(aiso_risk_level)
            .attr("data-hint-risk", aiso_risk_level);

        setTimeout(() => {
            $(this.elms.continueBtn)
                .removeClass("is-loading")
                .prop("disabled", false);

            $briefingPopup.addClass("is-open is-for-part2");
        }, 1500);
    }

    onCloseBriefingPopupPart2() {
        const elms = this.elms;
        const $briefingPopup = $(".js-briefing");
        const $puzzle2Btn = $(elms.partTwoBtn);
        const isForPart2 = $briefingPopup.hasClass("is-for-part2");

        if(isForPart2) {
            $briefingPopup.removeClass("is-for-part-2");
            setTimeout(() => {
                $puzzle2Btn.trigger("click");
            }, 1570);
        }
    }

    goToPuzzlePartTwo() {
        const elms = this.elms;
        const $puzzlePartTwo = $(elms.puzzlePartTwoScreen);

        $puzzlePartTwo.addClass("is-open");
        
        $(elms.hintBtn).removeClass("is-hidden")
        $(".js-part-nav").addClass("is-hidden")

        setTimeout(() => {
            this.setRequiremtnSlider();

            setTimeout(() => {
                $(".matchCards__authentication-container").css("opacity", "1")
            }, 500)
        }, 1000);
    }

    onDeleteInputAnswer(e, el) {
        const $el = $(el);
        const keyCode = e.keyCode || e.which;
        const isDeleteKey = keyCode === 8;
        const $current = $el.parent();
        const $previousInput = $current.prev();

        if (!isDeleteKey) return;

        $current.find("input").val("");
        $previousInput.find("input").trigger("focus");

        this.toggleCheckButton();
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const elms = this.elms;
        const $submitBtn = $(elms.checkAnswer);
        const $questionPopup = $(elms.puzzlePartTwoScreen);

        if ($submitBtn.hasClass("is-completed")) {
            return false;
        }

        $questionPopup.removeClass("is-incorrect");

        const regex = new RegExp("^[a-zA-Z0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);

        if (!regex.test(key)) {
            this.toggleCheckButtonPart2();
            return false;
        }

        const value = String($el.val(e.key));

        const $current = $el.parent();
        const $nextInput = $current.next();

        if (value.trim() !== "" && $nextInput.length) {
            $el.trigger("blur");
            $nextInput.find("input").trigger("focus");
        }

        this.toggleCheckButtonPart2();
    }

    onBlurInput(e) {
        let $this = $(e.currentTarget);
        let val = String($this.val());
        let display = $this.next();

        display.removeClass("on-input");
        display.text(val.trim());
    }

    onInputFocus(e) {
        const $this = $(e.currentTarget);
        const display = $this.next();
        const val = String($this.val());

        display.addClass("on-input");

        if (val.trim() === "") {
            display.text("");
        }

        if (val.trim().length) {
            $this[0].setSelectionRange(val.length - 1, val.length);
        }
    }

    toggleCheckButtonPart2() {
        const elms = this.elms;
        const $questionPopup = $(elms.puzzlePartTwoScreen);
        const $checkBtn = $questionPopup.find(elms.checkAnswer);
        const $answers = $questionPopup.find(elms.inputAnswer);
        let isAllAnswered = true;

        $.each($answers, function (index, elAnswer) {
            const answer = String($(elAnswer).val());
            if (answer.trim() == "") {
                isAllAnswered = false;
                return false;
            }
        });

        return $checkBtn
            .prop("disabled", !isAllAnswered)
            .toggleClass("valid", isAllAnswered);
    }

    /* check player answers on puzzle part 2 */
    onSubmitAnswerPart2(e, el) {
        const $el = $(el);
        const elms = this.elms;

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $questionPopup = $el.parents(elms.puzzlePartTwoScreen);
        const $answers = $questionPopup.find(elms.inputAnswer);

        $el.addClass("is-loading").prop("disabled", true);
        $questionPopup.removeClass("is-wrong");

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);

        let isCorrect = false;
        let playerAnswer = "";
        let statusClass = "is-incorrect";

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            playerAnswer += $answer.val();
        });

        const correctAnswer = roomAnswers?.part_2 || false;

        // playerAnswer = playerAnswer.toLowerCase();

        if (playerAnswer === correctAnswer) {
            isCorrect = true;
        }

        const updateData = {
            part_2: playerAnswer
        };

        if (isCorrect) {
            statusClass = "is-correct";
            $answers.prop("readonly", true);

            const onSuccessUpdate = () => {
                $el
                    .removeClass("is-loading valid")
                    .addClass("is-completed");

                // setTimeout(() => {
                    $questionPopup.removeClass("is-open");
                    $(elms.partTwoBtn).addClass("is-completed")
                    $(elms.hintBtn).addClass("is-hidden")
                    $(elms.puzzleScreen)
                        .removeClass("secondary-view")
                        .addClass("tertiary-view");

                    maybeUpdateRoomStatus(roomId, "is-status-completed");
                // }, 2000);
            };

            const onErrorUpdate = () => { };

            updateFinalRoomAnswer(roomId, updateData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
        }

        $questionPopup.addClass(statusClass);
        $el.removeClass("is-loading");
    }

    onPuzzlePartTwoFinish() {
        const elms = this.elms;

        $(elms.puzzlePartTwoScreen).removeClass("is-open");

       

       
    }
}
